<template>
    <v-container fluid>
        <v-img src="@/assets/race26/DSC_1919.JPG" gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)" class="landing-img">
            <div class="landing-container">
                <h1 style="font-size:50px; font-weight: bold;">EXEC TEAM</h1>
            </div>
        </v-img>
        <div class="team-layout">
            <h1 style="font-size:50px; font-weight: bold; text-align: center;">Current Team</h1> 
            <div class="team-columns">
                <Profile
                    v-for="(member, i) in members.slice(0, 16)"
                    :key="i"
                    :FirstName="member.firstName"
                    :LastName="member.lastName"
                    :Position="member.position"
                    :LinkedIn="member.linkedIn"
                >
                    <template v-slot:avatar>
                        <v-img
                            class="avatar"
                            :src="member.src ? require('../assets/team/new26/' + member.src) : ''"
                        ></v-img>
                    </template>
                </Profile>
            </div>
        </div>
        <div class="team-layout">
            <h1 style="font-size:50px; font-weight: bold; text-align: center;">Advisors</h1> 
            <div class="team-columns">
                <Profile
                    v-for="(member, i) in members.slice(16)"
                    :key="i"
                    :FirstName="member.firstName"
                    :LastName="member.lastName"
                    :Position="member.position"
                    :LinkedIn="member.linkedIn"
                >
                    <template v-slot:avatar>
                        <v-img
                            class="avatar"
                            :src="member.src ? require('../assets/team/new26/' + member.src) : ''"
                        ></v-img>
                    </template>
                </Profile>
            </div>
        </div>
    </v-container>
</template>

<script>
import Profile from "@/components/Profile.vue";
export default {
    name: "Team",
    components: {
        Profile,
    },
    data() {
        return {
            members: [
                { firstName: "Mark", lastName: "Chen", position: "Project Manager", linkedIn: "https://www.linkedin.com/in/mark-si-chen/", src:"mark.png"},
                { firstName: "Lana", lastName: "Yong", position: "Mechanical Lead - Aeroshell", linkedIn: "https://www.linkedin.com/in/lanayong/", src: "Lana_Headshot-photoaidcom-cropped.JPG"},
                { firstName: "Vincent", lastName: "Bozzo", position: "Mechanical Manager", linkedIn: "https://www.linkedin.com/in/vincentbozzo/", src: "Vincent_Headshot-photoaidcom-cropped.JPG" },
                { firstName: "Ethan", lastName: "Munoz Yu", position: "Mechanical Lead - Suspension", linkedIn: "https://www.linkedin.com/in/ethanmunozyu/", src: "Ethan_Headshot-photoaidcom-cropped.JPG" },
                { firstName: "Dennis", lastName: "Cao", position: "Electrical Manager", linkedIn: "https://www.linkedin.com/in/dennis-cao-10bba3223/", src:"Dennis_Headshot-photoaidcom-cropped.JPG"},
                { firstName: "Leo", lastName: "Jiang", position: "Electrical Manager", linkedIn: "https://www.linkedin.com/in/leo-runshi-jiang/", src: "Leo_Headshot-photoaidcom-cropped.JPG" },
                { firstName: "Vince", lastName: "Simone Amado", position: "Electrical Lead - High Voltage", linkedIn: "https://www.linkedin.com/in/vinceamadoin/", src:"Vince_Headshot-photoaidcom-cropped.JPG"},
                { firstName: "Ryan", lastName: "Su", position: "Electrical Lead - Low Voltage", linkedIn: "https://www.linkedin.com/in/ryan-su-51847625a/", src: "Ryan_Headshot-photoaidcom-cropped.JPG" },
                { firstName: "David", lastName: "Cosentino", position: "Electrical Lead - Battery", linkedIn: "https://www.linkedin.com/in/david-cosentino-859991253/", src:"David_Headshot-photoaidcom-cropped.JPG"},
                { firstName: "Alisha", lastName: "Bhogal", position: "Electrical Lead - Solar Cells", linkedIn: "https://www.linkedin.com/in/alisha-bhogal/", src:"Alisha.jpg"},
                { firstName: "Paul", lastName: "Stoica", position: "Electrical Lead - Solar Cells", linkedIn: "", src: "Paul_Headshot-photoaidcom-cropped.JPG" },
                { firstName: "Darius", lastName: "D'Mello", position: "Electrical Lead - Firmware", linkedIn: "https://www.linkedin.com/in/darius-dmello/", src: "Darius_Headshot-photoaidcom-cropped.JPG" },
                {firstName: "Joshua", lastName: "Xue", position: "Electrical Lead - Battery", linkedIn: "https://www.linkedin.com/in/joshuaxue/", src:"1759860838585.jpeg"},
                { firstName: "Guneev", lastName: "Arora", position: "Software Lead - Webdev", linkedIn: "https://www.linkedin.com/in/guneevarora", src:"Guneev_Headshot.jpg"},
                { firstName: "Krishna", lastName: "Chauhan", position: "Software Lead - Strategies", linkedIn: "https://www.linkedin.com/in/krishna-chauhan-79a57720b/", src:"Krishna_Headshot.png"},
                { firstName: "Raj", lastName: "Pandya", position: "Business Lead", linkedIn: "https://www.linkedin.com/in/raj-pandya-/", src: "raj.jpg" },
                { firstName: "Alice", lastName: "Guo", position: "Media Lead", linkedIn: "https://www.linkedin.com/in/alice-guo-3b1747250/", src: "alice.jpg" },
                // Advisors in separate section
                { firstName: "Eddy", lastName: "Su", position: "Advisor", linkedIn: "https://www.linkedin.com/in/che-su-mac", src:"esu.png"},
                { firstName: "Kavish", lastName: "Wadehra", position: "Advisor", linkedIn: "https://www.linkedin.com/in/kavish-wadehra", src:"Kavish_headshot-modified.png"},
                { firstName: "Anand", lastName: "Jinesh", position: "Advisor", linkedIn: "https://www.linkedin.com/in/anandjinesh", src:"ajinesh.png"},
                { firstName: "Valerie", lastName: "Stephens", position: "Advisor", linkedIn: "https://www.linkedin.com/in/valerie-stephens/", src:"valerie stephens.jpg"},
                { firstName: "Aryan", lastName: "Patel", position: "Advisor", linkedIn: "https://www.linkedin.com/in/aryanptl", src:"Aryan_Headshot.jpg"},
                { firstName: "Grigor", lastName: "Pahlevanyan", position: "Advisor", linkedIn: "https://www.linkedin.com/in/grigorpahlevanyan", src:"Profile Pic - mcmastersolarcar.jpg"},
                { firstName: "Sandy", lastName: "Diep", position: "Advisor", linkedIn: "https://www.linkedin.com/in/sandy-diep-6280a4175/", src:"Sandy_Headshot-photoaidcom-cropped.JPG"},
                { firstName: "Lewis", lastName: "Gross", position: "Advisor", linkedIn: "https://www.linkedin.com/in/lewis-gross", src:"lgross.png"},
                { firstName: "Anthony", lastName: "Seymour", position: "Advisor", linkedIn: "https://www.linkedin.com/in/anthony-matthew-seymour", src:"aseymour.png"},
            ]
        }
    }
};
Profile;
</script>

<style lang="scss" scoped>
.landing-img {
    .landing-container {
        color: white;
        width: 100%;
        height: 100%;
        // padding: 300px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-shadow: 2px 2px 2px #000000;

        h1 {
            font-weight: 400;
        }
    }
}

.team-layout {
    width: 100%;
}

.team-columns {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    gap: 6em;
    padding: 5em 3em 5em;
}
</style>
